import React, { useState } from 'react';

import WindowDialog from 'views/widgets/WindowDialog.jsx';
import AttributeTagSearchViewer from 'views/widgets/AttributeTagSearchViewer.jsx';

export default function FiltersDialog(props) {

	let { filters, okCallback, cancelCallback } = props;

	const [attributes, setAttributes] = useState(filters ? JSON.parse(filters) : []);

	const widthMatches = window.matchMedia("(min-width: 850px)").matches;
	const heightMatches = window.matchMedia("(min-height: 700px)").matches;
	
	const getButtons = () => {
		return [
			(<button
				tabIndex={0}
				key="ok-btn"
				className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
				onClick={() => okCallback(JSON.stringify(attributes))}
			>
				OK
			</button>),
			(<button
				tabIndex={0}
				key="cancel-btn"
				className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
				onClick={cancelCallback}
			>
				Cancel
			</button>)
		];
	};
	
	const render = () => {
		return (
	    	<div
	        	style={{
					width: "calc(100% - 20px)",
					height: "calc(100% - 28px)",
					padding: "0px 10px 10px 10px"
	            }}
			>
				<h3>Attributes</h3>
				<AttributeTagSearchViewer
					attributes={attributes}
					attributesChanged={(newAttributes) => setAttributes(newAttributes)}
				/>
	        </div>		
		);
	};

	return (
		<WindowDialog
			title={"Filters"}
			onClose={cancelCallback}
			initialHeight={heightMatches ? 700 : 400}
			minHeight={350}
			initialWidth={widthMatches ? 850 : 400}
			minWidth={400}
			render={render}
			buttons={getButtons()}
		/>
	);
}